export type AppVariant = 'unsw-frontend' | 'unsw-university' | 'ucl-frontend'

export interface FeatureFlags {
  // App-specific features
  enableQuizzes: boolean
  enableLiveEvent: boolean
  enableProgressDashboard: boolean
  enableFacultyOnboarding: boolean
  enableBusiness: boolean

  // Migration flags (for incremental migration)
  useNewRouter: boolean
  useNewQueryClient: boolean
  useNewUiComponents: boolean
}

const defaultFlags: FeatureFlags = {
  enableQuizzes: false,
  enableLiveEvent: false,
  enableProgressDashboard: false,
  enableFacultyOnboarding: false,
  enableBusiness: false,
  useNewRouter: true,
  useNewQueryClient: true,
  useNewUiComponents: true,
}

const appFlags: Record<AppVariant, Partial<FeatureFlags>> = {
  'unsw-frontend': {
    enableQuizzes: true,
    enableLiveEvent: true,
    enableProgressDashboard: true,
    enableFacultyOnboarding: false,
    enableBusiness: true,
  },
  'unsw-university': {
    enableQuizzes: true,
    enableLiveEvent: false,
    enableProgressDashboard: false,
    enableFacultyOnboarding: true,
  },
  'ucl-frontend': {
    enableQuizzes: true,
    enableLiveEvent: true,
    enableProgressDashboard: true,
    enableFacultyOnboarding: false,
  },
}

let currentAppVariant: AppVariant = 'unsw-frontend'
let cachedFlags: FeatureFlags | null = null

export function setAppVariant(variant: AppVariant) {
  currentAppVariant = variant
  cachedFlags = null // Reset cache
}

export function getAppVariant(): AppVariant {
  return currentAppVariant
}

export function getFeatureFlags(): FeatureFlags {
  if (cachedFlags) return cachedFlags

  cachedFlags = {
    ...defaultFlags,
    ...appFlags[currentAppVariant],
  }

  return cachedFlags
}

export function isFeatureEnabled(flag: keyof FeatureFlags): boolean {
  return getFeatureFlags()[flag]
}

/**
 * React hook for feature flags
 */
export function useFeatureFlag(flag: keyof FeatureFlags): boolean {
  return isFeatureEnabled(flag)
}
